import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

export function runRedirectBridge(): void {
    broadcastResponseToMainFrame();
}
